import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import img2 from "../assets/img2.png";
import star from "../assets/star.png";
import starWhite from "../assets/starWhite.png";
import fb from "../assets/fb.png";
import insta from "../assets/insta.png";
import tiktok from "../assets/tiktok.png";
import logo from "../assets/logo.png";
import {
  getReviewsById,
  saveOrder,
  saveStockNotification,
} from "../Utils/Utils";
import ImageSlider from "./MUI/ImagesSilder";
import Tabs from "./MUI/Tabs";
import TableComponent from "./MUI/TableComponent";
import AlertOverlay from "./MUI/AlertOverlay";
import { useCart } from "../Context/CartContext";
import { useAuth } from "../Context/AuthContext";
import { getAllProducts } from "../Utils/Utils";
import OverlayContainer from "./MUI/OverlayContainer";
import SelectOption from "../Components/MUI/SelectOption";

const ProductDetails = ({ pageContent }) => {
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [productToOrder, setProductToOrder] = useState(null);

  const location = useLocation();
  const { productId } = useParams();

  const params = useParams();
  const [product, setProduct] = useState(location.state?.product || null);

  console.log(product);
  const [reviews, setReviews] = useState([]);
  const [emailNotif, setEmailNotif] = useState("");
  const [phoneNotif, setPhoneNotif] = useState("");
  const [formMsg, setFormMsg] = useState("");
  const [alertState, setAlertState] = useState({
    open: false,
    title: "",
    message: "",
  });

  const [activeVariantIndex, setActiveVariantIndex] = useState(0);

  const columns = [
    { key: "Specification", label: "Specification" },
    { key: "Value", label: "Value" },
  ];

  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [wilaya, setWilaya] = useState("");
  const [adresse, setAdresse] = useState("");

  const [email, setEmail] = useState("");

  const { currentUser } = useAuth();

  useEffect(() => {
    if (showOrderForm && currentUser) {
      if (currentUser.name) setName(currentUser.name);
      if (currentUser.email) setEmail(currentUser.email);
      if (currentUser.phone) setNumber(currentUser.phone);
    }
  }, [showOrderForm, currentUser]);

  const { addItem, setIsOpen } = useCart();

  const algeriaWilayas = [
    "Adrar",
    "Chlef",
    "Laghouat",
    "Oum El Bouaghi",
    "Batna",
    "Béjaïa",
    "Biskra",
    "Béchar",
    "Blida",
    "Bouira",
    "Tamanrasset",
    "Tébessa",
    "Tlemcen",
    "Tiaret",
    "Tizi Ouzou",
    "Alger",
    "Djelfa",
    "Jijel",
    "Sétif",
    "Saïda",
    "Skikda",
    "Sidi Bel Abbès",
    "Annaba",
    "Guelma",
    "Constantine",
    "Médéa",
    "Mostaganem",
    "MSila",
    "Mascara",
    "Ouargla",
    "Oran",
    "El Bayadh",
    "Illizi",
    "Bordj Bou Arreridj",
    "Boumerdès",
    "El Tarf",
    "Tindouf",
    "Tissemsilt",
    "El Oued",
    "Khenchela",
    "Souk Ahras",
    "Tipaza",
    "Mila",
    "Aïn Defla",
    "Naâma",
    "Aïn Témouchent",
    "Ghardaïa",
    "Relizane",
    "Timimoun",
    "Bordj Badji Mokhtar",
    "Ouled Djellal",
    "Beni Abbès",
    "In Salah",
    "In Guezzam",
    "Touggourt",
    "Djanet",
    "El M'Ghair",
    "El Meniaa",
  ];

  const total = 0;
  const handleSubmit = () => {
    if (!name || !number || !wilaya || !adresse || !quantity) {
      alert("Veuillez remplir tous les champs requis.");
      return;
    }

    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];

    const order = {
      orderStatus: true,
      paymentStatus: true,
      products: [
        {
          productId: product.id,
          productName: product.productName,
          variant: activeVariantIndex !== 0 ? activeVariantIndex - 1 : null,
          quantity: quantity,
        },
      ],
      clientName: name,
      clientPhone: number,
      variant: activeVariantIndex !== 0 ? activeVariantIndex - 1 : null,
      total: quantity * productToOrder.price,
      date: formattedDate,
      updatedAt: formattedDate,
      wilaya,
      address: adresse,
      email: email,
      appSource: "active Fitness Web App",
    };

    console.log("Commande soumise :", order);
    // Save order to server or state here

    saveOrder(order).then(() => {
      setShowOrderForm(false);
      handleCancel();

      setAlertState({
        open: true,
        title: "Succès",
        message:
          "Commande Enregistrée avec succès. Vous recevrez notre appel pour la confirmation de commande.",
      });
    });
  };
  const handleCancel = () => {
    setName("");
    setNumber("");
    setQuantity(1);
  };

  const generateSpecsData = (item) => {
    return [
      {
        Specification: "Brand",
        Value: item && item.brandName ? item.brandName : "N/A",
      },
      {
        Specification: "Product Name",
        Value: item && item.productName ? item.productName : "N/A",
      },
      {
        Specification: "Availability Date",
        Value: item && item.availabilityDate ? item.availabilityDate : "N/A",
      },

      {
        Specification: "Price",
        Value: item && item.price ? `${item.price} DA` : "N/A",
      },
      {
        Specification: "Tags",
        Value: (item && item.tags?.join(", ")) || "N/A",
      },
    ];
  };

  const generateTabsData = (item) => {
    const specsData = generateSpecsData(item);

    return [
      {
        buttonContent: <p>Description</p>,
        content: (
          <div>
            <p className="bold grey">
              Active Fitness<span className="orange">.</span> PRODUCT
            </p>
            <p className="small-text grey">
              {item && item.brandName ? item.brandName : null}
            </p>
            <p className="sec-text">
              {item && item.productName ? item.productName : null}
            </p>
            <p className="my-20 small-text">
              {item && item.productDescription ? item.productDescription : null}
            </p>

            <p className="bold">Specification:</p>

            <p className="my-20 small-text" style={{ whiteSpace: "pre-line" }}>
              {item?.specifications?.replace(/\\n/g, "\n")}
            </p>
            <div className="flex">
              <div className="action-button bg-orange my-20">
                <p className="btn">
                  {item && item.price ? item.price : null} DA
                </p>
              </div>

              {product && product.outOfStock ? (
                <>
                  <div className="action-button bg-orange my-20 mx-20">
                    <p
                      className="btn"
                      onClick={() => {
                        // open order form for immediate checkout
                        setProductToOrder(item);
                        setShowOrderForm(true);
                      }}
                    >
                      Commander Maintenant
                    </p>
                  </div>

                  <div
                    className="action-button bg-orange my-20 mx-20"
                    onClick={() => {
                      try {
                        const selectedVariant =
                          activeVariantIndex === 0
                            ? null
                            : product.varients?.[activeVariantIndex - 1];
                        addItem({ ...item, variant: selectedVariant }, 1);
                        setAlertState({
                          open: true,
                          title: "Succès",
                          message: "Produit ajouté au panier",
                        });
                      } catch (e) {
                        console.error(e);
                        setAlertState({
                          open: true,
                          title: "Erreur",
                          message: "Impossible d\x27ajouter au panier",
                        });
                      }
                    }}
                  >
                    <p className="btn">Ajouter au Panier</p>
                  </div>
                </>
              ) : (
                <div className="action-button bg-red m-20">
                  <p className="btn">En Rupture</p>
                </div>
              )}
            </div>
            {product && !product.outOfStock ? (
              <div className="input-container">
                <p className="small-text grey mx-10">
                  Si vous voulez qu'on vous envoie une notifications des que le
                  produit est Disponible
                </p>
                <p className="small-text bold grey my-10">Email</p>

                <input
                  className="input  w-1-2 notif-form-input"
                  placeholder="Veuillez Saisir Votre Email"
                  value={emailNotif}
                  onChange={(e) => {
                    setEmailNotif(e.target.value);
                  }}
                  required
                />

                <p className="small-text bold grey my-10">
                  Numero de Telephone
                </p>
                <input
                  className="input  w-1-2 notif-form-input"
                  placeholder="Veuillez Saisir Votre Numero de Telephone (Optionelle)"
                  value={phoneNotif}
                  onChange={(e) => {
                    setPhoneNotif(e.target.value);
                  }}
                />

                <motion.p
                  initial={{ opacity: 0 }}
                  animate={formMsg ? { opacity: 1 } : { opacity: 0 }}
                  className="small-text grey bold my-10"
                >
                  {" "}
                  Veuillez Saisir Votre Email...
                </motion.p>
              </div>
            ) : null}
            {product && !product.outOfStock ? (
              <div className="flex align-items-center ">
                <div
                  className="action-button bg-orange"
                  onClick={() => {
                    if (emailNotif !== "") {
                      saveStockNotification(emailNotif, product.id, phoneNotif);
                      setEmailNotif("");
                      setAlertState({
                        open: true,
                        title: "Merci!",
                        message:
                          "Vous serez notifié une fois l\x27article en stock.",
                      });
                    } else {
                      setFormMsg(true);
                      setTimeout(() => {
                        setFormMsg(false);
                      }, 3000);
                    }
                  }}
                >
                  <p className="btn">Me Notifie</p>
                </div>
              </div>
            ) : null}

            <div className="reviews-container my-10 flex align-items-center">
              {reviews.length === 0 ? (
                <div className="review-container bg-grey flex align-items-center justify-center relative px-10 py-10 box-sizing border-radius-5 mr-10">
                  <p className="grey small-text center-text absolute">
                    ' No Reviews Yet '
                  </p>
                </div>
              ) : (
                reviews.map((review) => (
                  <div className="review-container flex-column justify-center bold black relative px-10 py-10 box-sizing bg-grey border-radius-5 mr-10">
                    <p className="small-text">
                      {review.reviewerName}
                      <br />
                      <span className="grey smaller-text">
                        {review.createdAt}
                      </span>
                    </p>
                    <p className="grey small-text my-10 center-text">
                      ' {review.reviewText} '
                    </p>
                    <div className="flex justify-space-between w-full">
                      {new Array(parseInt(review.rating))
                        .fill(undefined)
                        .map((_, idx) => (
                          <img key={idx} alt="star" src={starWhite} />
                        ))}
                      {new Array(5 - parseInt(review.rating))
                        .fill(undefined)
                        .map((_, idx) => (
                          <img
                            key={`empty-${idx}`}
                            alt="star"
                            src={starWhite}
                          />
                        ))}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        ),
      },
      {
        buttonContent: <p>Specification</p>,
        content: (
          <div>
            <TableComponent data={specsData} columns={columns} />
          </div>
        ),
      },
      {
        buttonContent: <p>Manuals</p>,
        content: (
          <div>
            <p>
              Download user manuals and guides for product setup and
              maintenance.
            </p>
            {item &&
              item.maunalFile?.map((file, idx) => (
                <a
                  key={idx}
                  href={file}
                  target="_blank"
                  rel="noreferrer"
                  className="my-20"
                >
                  Manual {idx + 1}.pdf
                </a>
              ))}
          </div>
        ),
      },
    ];
  };

  const variantTabs = [
    {
      buttonContent: (
        <div className="" onClick={() => setActiveVariantIndex(0)}>
          <img
            className="tab-icon variant-tab-img"
            alt=""
            src={product && product.imagesUrls?.[0]}
          />
          <p className="black small-text bold center-text">
            {product && product.productName ? product.productName : null}
          </p>
        </div>
      ),
      content: <Tabs tabs={generateTabsData(product)} className={"var-tabs"} />,
    },
    ...(product &&
    Array.isArray(product.varients) &&
    product.varients.length > 0
      ? product.varients.map((variant, idx) => ({
          buttonContent: (
            <div onClick={() => setActiveVariantIndex(idx + 1)}>
              <img
                className="tab-icon variant-tab-img"
                alt=""
                src={variant.imagesUrls?.[0]}
              />
              <p className="black small-text bold center-text">
                {variant && variant.productName ? variant.productName : null}
              </p>
            </div>
          ),
          content: (
            <Tabs tabs={generateTabsData(variant)} className={"sec-tabs"} />
          ),
        }))
      : []),
  ];

  useEffect(() => {
    window.scrollTo(0, 0);

    // First check if we have product in location state (from navigation)
    if (location.state?.product) {
      setProduct(location.state.product);
      // Fetch reviews for this product
      getReviewsById(location.state.product.id).then(setReviews);
    } else {
      // If no location state (page reload), fetch the product by ID
      getAllProducts().then((all) => {
        const productsArray = Object.values(all);
        const found = productsArray.find((p) => p.id === productId);
        if (found) {
          setProduct(found);
          // Fetch reviews for this product
          getReviewsById(found.id).then(setReviews);
        }
      });
    }
  }, [productId, location.state]);

  return (
    <>
      {product && (
        <motion.div
          id="section2"
          className="prodcutDetails section section2 w-full h-full flex justify-space-between px-80 box-sizing"
          initial={{ top: "50px", opacity: 0 }}
          animate={{ top: "0", opacity: 1, transition: { delay: 0.5 } }}
        >
          <p className="grey small mobile mobile-small-heading bold">
            Active Fitness Product
          </p>
          <p className="black bold mobile-heading mobile ">
            {product.productName}
          </p>

          <div className="w-25 flex relative align-items-center justify-center details-left  h-full  border-radius-5 bg- white">
            <motion.div className="details-slider">
              <ImageSlider
                images={
                  activeVariantIndex === 0
                    ? product.imagesUrls
                    : product.varients?.[activeVariantIndex - 1]?.imagesUrls ||
                      []
                }
              />
            </motion.div>
          </div>
          <div className="flex details-right w-75  flex-column justify-center px-80 py-80 box-sizing">
            <Tabs tabs={variantTabs} className={"vars-tab"} />

            <div className="flex justify-space-between align-items-center w-full">
              <div className="action-button bg-orange my-20"></div>

              <div className="">
                <img
                  alt=""
                  src={fb}
                  className="inverted-image50 logo-img mx-10 social-icon"
                  onClick={() => {
                    if (
                      pageContent &&
                      pageContent["contact-info"] &&
                      pageContent["contact-info"]["facebook"]
                    )
                      window.open(
                        pageContent["contact-info"]["facebook"],
                        "_blank",
                      );
                  }}
                />
                <img
                  alt=""
                  src={insta}
                  className="inverted-image50 logo-img mx-10 social-icon"
                  onClick={() => {
                    if (
                      pageContent &&
                      pageContent["contact-info"] &&
                      pageContent["contact-info"]["facebook"]
                    )
                      window.open(
                        pageContent["contact-info"]["instagram"],
                        "_blank",
                      );
                  }}
                />
                <img
                  alt=""
                  src={tiktok}
                  className="inverted-image50 logo-img mx-10 social-icon"
                  onClick={() => {
                    if (
                      pageContent &&
                      pageContent["contact-info"] &&
                      pageContent["contact-info"]["facebook"]
                    )
                      window.open(
                        pageContent["contact-info"]["tiktok"],
                        "_blank",
                      );
                  }}
                />
              </div>
            </div>
          </div>

          <OverlayContainer
            contentWidth={"40vw"}
            contentHeight={"90vh"}
            stat={showOrderForm}
            className={"order-form-overlay"}
            toggleOverlay={() => setShowOrderForm(false)}
            noExitBtn={false}
            children={
              <div className="order-form-content">
                <form>
                  <div className="input-container">
                    <label className="bold">Product :</label>
                    <div className="input flex align-items-center">
                      {productToOrder && productToOrder.productName
                        ? productToOrder.productName
                        : null}{" "}
                    </div>
                  </div>

                  <div className="input-container">
                    <label htmlFor="name" className="bold">
                      Nom :
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="input"
                      placeholder="Entrez votre nom"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="input-container">
                    <label htmlFor="number" className="bold">
                      Numéro De Telephone:
                    </label>
                    <input
                      type="tel"
                      id="number"
                      className="input"
                      placeholder="Entrez votre numéro De Telephone"
                      value={number}
                      onChange={(e) => setNumber(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-container">
                    <label htmlFor="number" className="bold">
                      Email :
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="input"
                      placeholder="Entrez votre Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-container">
                    <label>Wilaya</label>
                    <select
                      className="input"
                      value={wilaya}
                      onChange={(e) => setWilaya(e.target.value)}
                      required
                    >
                      <option value="">-- Choisir une wilaya --</option>
                      {algeriaWilayas.map((w, index) => (
                        <option key={index} value={w}>
                          {w}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="input-container">
                    <label htmlFor="quantity" className="bold">
                      Adresse :
                    </label>
                    <input
                      type="text"
                      id="adresse"
                      className="input"
                      placeholder="Entrez Votre Adresse"
                      value={adresse}
                      onChange={(e) => setAdresse(e.target.value)}
                      required
                    />
                  </div>

                  <div className="input-container">
                    <label htmlFor="quantity" className="bold">
                      Quantité :
                    </label>
                    <input
                      type="number"
                      id="quantity"
                      className="input"
                      placeholder="Entrez la quantité"
                      min="1"
                      value={quantity}
                      onChange={(e) =>
                        setQuantity(parseInt(e.target.value) || 1)
                      }
                    />
                  </div>

                  <div className="input-container">
                    <label className="bold">Prix total :</label>
                    <div className="input flex align-items-center">
                      {productToOrder && productToOrder.price
                        ? productToOrder.price * quantity
                        : null}{" "}
                      DZD
                    </div>
                  </div>

                  <div className="flex order-form-actions">
                    <div className="action-button  my-20 mx-20 flex justify-center align-items-center">
                      <p
                        className=" grey bold small-text"
                        onClick={() => {
                          handleCancel();
                          setShowOrderForm(false);
                        }}
                      >
                        Annuler
                      </p>
                    </div>

                    <div className="action-button bg-orange my-20">
                      <p className="btn" onClick={handleSubmit}>
                        Confirmer
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            }
          />
        </motion.div>
      )}
      <AlertOverlay
        stat={alertState.open}
        title={alertState.title}
        message={alertState.message}
        onClose={() => setAlertState((prev) => ({ ...prev, open: false }))}
        autoCloseMs={2500}
      />
    </>
  );
};

export default ProductDetails;
